import RBush from 'rbush';

import { IFrecklesRBushItem } from '../../../../../../common/types/freckles';
import { IRBushItem } from '../../../../../../common/types/map';
import { makeContextModule } from '../../../../../../common/utils/makeContextModule';

export interface IFeaturesContext {
  rbush: RBush<IRBushItem>;
  rbushFreckles: RBush<IFrecklesRBushItem>;
  pointsLayer: YMaps.PointsLayer;
  frecklesPointsLayer: YMaps.FrecklesPointsLayer;
  hotspotsLayer: YMaps.HotspotsLayer;
  balloonManager: YMaps.BalloonManager;
}

export const {
  Context: FeaturesContext,
  useContext: useFeaturesContext,
  withContext: withFeaturesContext,
} = makeContextModule<IFeaturesContext>({
  contextName: 'FeaturesContext',
});
